const text = {
  PRE_ASSMNT_SUCCESS_TITLE: "Great Work!",
  PRE_ASSMNT_SUCCESS_MSG:
    "Your profile setup is now complete. You can start creating assessments and keep track of your progress.",
  GO_TO_DASHBOARD: "GO TO DASHBOARD",
  download_report: "DOWNLOAD REPORT",
  downloading: "DOWNLOADING",
  download_pdf: "Download as PDF",
  download_csv: "Download as CSV",
  view: "VIEW",
  update: "UPDATE",
};

export default text;
